
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import { AgentResource, AgentReferenceTypeResource } from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";

import { AgentFacilityResourceSelect } from "../../../models/ui/manageAgent";

const systemModule = getModule(SystemModule);

@Component
export default class ManageAccessorialCharges extends Vue {
  @Prop()
  agent: AgentResource;

  @Prop()
  public agentReferenceTypes: Array<AgentReferenceTypeResource>;

  filterString:string='';

  loading: boolean = false;
  loadingPage: boolean = false;

  agentReferenceType: AgentReferenceTypeResource = {
    id: null,
    agentId: null,
    referenceNumberType: null,
    agentReferenceNumberType: null,
    description: null,
    isActive: true
  };

  isReferenceTypeModalVisible: boolean = false;
  isDeleteReferenceTypeModalVisible: boolean = false;

  async addAgentReferenceType() {
    this.agentReferenceType = {
      id: null,
      agentId: this.agent.id,
      referenceNumberType: null,
      agentReferenceNumberType: null,
      description: null,
      isActive: true
    };

    this.isReferenceTypeModalVisible = true;
  }

  async editAgentReferenceType(id: number) {
    let clone = this.agentReferenceTypes.find(x => x.id === id);
    clone = { ...clone };

    this.agentReferenceType = clone;
    this.isReferenceTypeModalVisible = true;
  }

  async saveAgentReferenceType() {
    try {
      this.agentReferenceType.agentId = this.agent.id;
      if (this.agentReferenceType.id === null) {
        await systemModule.postAgentReferenceType(this.agentReferenceType);
      } else {
        await systemModule.putAgentReferenceType(this.agentReferenceType);
      }
      notifications.success("Success", `Reference type saved.`);
    } catch (error) {
      notifications.error("Save Failed", "Unable to save reference type.", error);
    }

    this.$emit("updated");
  }

  showAgentReferenceTypeDeleteConfirmation(id: number) {
    let clone = this.agentReferenceTypes.find(x => x.id === id);
    clone = { ...clone };

    this.agentReferenceType = clone;
    this.isDeleteReferenceTypeModalVisible = true;
  }

  async deleteAgentReferenceType() {
    try {
      await systemModule.deleteAgentReferenceType(this.agentReferenceType.id);
      notifications.success("Success", `Reference type deleted.`);
    } catch (error) {
      notifications.error("Delete Failed", "Unable to delete reference type.", error);
    }
    this.$emit("updated");
  }
}
